import store from './../../../../../Store';
import { useState } from 'react';

export function useSavedInput(paramName: string, defaultValue: any) {
  let initialValue = defaultValue;

  const seedingParams = store.getState().prescription.currentJob.seedingCalculatorParams;

  if (seedingParams && seedingParams[paramName]) {
    initialValue = seedingParams[paramName];
  }

  const [value, setValue] = useState(initialValue);

  return [value, setValue];
}
